import Image from "components/Image";
import styles from "./IdeasArticleByline.module.scss";
import { gql } from "utils/urql";
import cx from "classnames";
import { IdeasArticleBylineFragment } from "types/api";

const IdeasArticleByline = ({ authors }: IdeasArticleBylineFragment) => {
  return (
    <div className={styles.root}>
      {authors.map((author, index) => {
        return (
          <address
            key={author.id}
            id={`article-writer-${index}`}
            className={styles.articleAuthor}
            data-author-id={author.id}
          >
            {author.ideasHeadshot && author.ideasHeadshot.srcSet && (
              <div className={styles.authorImage}>
                <figure className={cx(styles.oMedia, styles.authorMedia)}>
                  <a
                    className={styles.oMediaObject}
                    href={author.url}
                    title={`${author.displayName}'s writer page`}
                    data-action="click author - byline image"
                    data-label={author.url}
                  >
                    <picture className={styles.authorPicture}>
                      <Image
                        lazy={true}
                        width={author.ideasHeadshot.width}
                        height={author.ideasHeadshot.height}
                        className={styles.authorImg}
                        src={author.ideasHeadshot.url}
                        srcSet={author.ideasHeadshot.srcSet}
                        alt={author.ideasHeadshot.altText || ""}
                      />
                    </picture>
                  </a>
                </figure>
              </div>
            )}

            <div className={styles.authorContent}>
              <div>
                <a
                  className={styles.authorLink}
                  href={author.url}
                  data-action="click author - byline"
                  data-label={author.url}
                >
                  {author.displayName}
                </a>
              </div>
              {author.biography?.short && (
                <div
                  className={styles.authorBio}
                  dangerouslySetInnerHTML={{
                    __html: author.biography.short,
                  }}
                />
              )}
            </div>
          </address>
        );
      })}
    </div>
  );
};

export default IdeasArticleByline;

IdeasArticleByline.fragment = gql`
  fragment ideasArticleByline on Article {
    authors {
      id
      url
      displayName
      ideasHeadshot: headshot(width: 72, height: 72, sizes: ["1x", "2x"]) {
        width
        height
        altText
        srcSet
        url
      }
      biography {
        short
      }
    }
  }
`;
